import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import DropList from 'components/atoms/DropList';
import Form from 'components/atoms/Form';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import Label from 'components/atoms/Label';
import { DEFAULT_VIEW_MODE } from 'data/static';
import { bindActionCreators, Dispatch } from 'redux';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';
import { Layout, RootState } from 'types';
import { ActionsType, SystemType } from 'types/system';
import { checkDifferent, setKey } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { withRouter } from 'utils/withRouter';

interface SettingModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    layout: Layout;

    system: SystemType;
    id?: string;
    setLayoutAction: SetLayoutAction;
    //unused props but used in state and getDerivedStateFromProps
    data: any;
    actions: ActionsType | undefined;
    navigate: (path: string) => void;
}

interface SettingModelState {
    //unused state
    errors: object;

    system: SystemType;

    //unused state
    data: any | null;
}

class SettingModel extends Component<SettingModelProps, SettingModelState> {
    constructor(props: SettingModelProps) {
        super(props);
        this.state = {
            system: props.system,
            data: {
                viewMode: props.layout.allowNavigation === true ? 'off' : props.layout.viewMode,
            },
            errors: {},
        };
    }

    static getDerivedStateFromProps(props: SettingModelProps, state: SettingModelState) {
        if (checkDifferent(props.system, state.system)) {
            return { system: props.system };
        }
        return null;
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();

        const viewMode = this.state.data.viewMode === 'off' ? DEFAULT_VIEW_MODE : this.state.data.viewMode;
        const allowNavigation = this.state.data.viewMode === 'off' ? true : false;
        this.props.setLayoutAction([
            {
                action: 'DEFAULT',
                data: {
                    viewMode,
                    allowNavigation,
                },
            },
            {
                action: 'ORDER_VIEW',
                data: {
                    viewMode: viewMode,
                },
            },
        ]);

        this.props.navigate(`/${viewMode === 'live' ? 'time' : viewMode}`);
        localStorage.setItem('viewMode', viewMode);
        localStorage.setItem('allowNavigation', JSON.stringify(allowNavigation));
        this.props.actions?.onCancel();
    };
    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    handleChange = (name: string, value: unknown) => {
        const { data, errors } = this.state;
        setKey(data, name, value);
        setKey(errors, name, null);
        this.setState({ data, errors });
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-4 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('System settings')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <FormGroup required={false}>
                        <Label>{translate('Landing tab')}</Label>
                        <DropList  capitalize
                            id="viewMode"
                            name="viewMode"
                            options={[
                                { value: 'live', label: translate('Replay Time') },
                                { value: 'chart', label: translate('Chart transit search') },
                                { value: 'grid', label: translate('Grid transit search') },
                                { value: 'off', label: translate('Off (return to last tab used)') },
                            ]}
                            value={this.state.data.viewMode}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    {/* <FormGroup required={false}>
                        <Label>{translate('Allow navigation')}</Label>
                        <DropList  capitalize
                            id="allowNavigation"
                            name="allowNavigation"
                            options={YES_AND_NO}
                            value={this.state.data.allowNavigation.toString()}
                            onChange={this.handleChange}
                        />
                    </FormGroup> */}

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button type="submit" className="px-4 py-2 bg-primary-submit rounded-md text-white">
                                {translate('Save')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const settingModelStateToProps = (state: RootState) => ({
    layout: state.layout.layout,
    system: state.port.system,
});

const settingModelDispatchToProps = (dispatch: Dispatch) => ({
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(settingModelStateToProps, settingModelDispatchToProps)(withRouter(SettingModel));
